import { Button, Direction, Displaying, Spacing } from "@bonusx-global/bx-design-system";
import { SparklesSolid } from "@bonusx-global/bx-icons";
import { useEventCallback } from "@mui/material";
import Box from "@mui/material/Box";
import { styled } from "@mui/system";
import { useEffect, useState } from "react";
import { CHATBOT_NAME } from "../../../../../features/ai-chatbot/constants/chatbot-name.const";
import { DrawerHtmlWrapper } from "./drawer-html-wrapper";

export interface GuidedModeExampleProps {
  example: string;
}

const ExampleContainer = styled(Box)({
  display: Displaying.flex,
  flexDirection: Direction.column,
  gap: Spacing[1500],
});

export function GuidedModeExample(props: Readonly<GuidedModeExampleProps>) {
  const { example } = props;
  const [showExample, setShowExample] = useState(false);
  const handleClick = useEventCallback(function onShowExample() {
    setShowExample(true);
  });

  useEffect(() => {
    setShowExample(false);
  }, [example]);

  return (
    <ExampleContainer>
      <Box sx={{ textAlign: "right" }}>
        <Button
          disabled={showExample}
          onClick={handleClick}
          color="purpleLight"
          variant="contained"
          size="large"
          startIcon={<SparklesSolid />}
        >
          Chiedi un esempio a {CHATBOT_NAME}
        </Button>
      </Box>
      {showExample && <DrawerHtmlWrapper html={example} />}
    </ExampleContainer>
  );
}
